<nav class="tab-section" [class.tab-navigation-active]="isNavigationActive() | async">
    <button
        *ngIf="isNavigationActive() | async"
        class="btn btn-left"
        (click)="navigateLeft()"
        [disabled]="(isDisabledButton() | async).left"
    ></button>
    <div #nav class="tabs-wrapper">
        <ul class="tabs reset" #tabs (scroll)="onElementScroll()">
            <li *ngFor="let tab of tabComponent" (click)="selectTab(tab, true); focusTab($event)" [class.active]="tab.active" class="tab">
                <button class="tab-section-label">{{ tab.title }}</button>
            </li>
        </ul>
    </div>
    <button
        *ngIf="isNavigationActive() | async"
        class="btn btn-right"
        (click)="navigateRight()"
        [disabled]="(isDisabledButton() | async).right"
    ></button>
</nav>
<ng-content></ng-content>
